var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export var RichEditorStyled = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  > div.mde-editor {\n    .mde-text {\n      font-family: ui-monospace, monospace;\n    }\n  }\n"], ["\n  display: block;\n  > div.mde-editor {\n    .mde-text {\n      font-family: ui-monospace, monospace;\n    }\n  }\n"])));
var templateObject_1;
//# sourceMappingURL=RichEditorStyled.js.map